import { render, staticRenderFns } from "./Foot.vue?vue&type=template&id=c1e7fc88&scoped=true"
import script from "./Foot.vue?vue&type=script&lang=ts"
export * from "./Foot.vue?vue&type=script&lang=ts"
import style0 from "./foot.css?vue&type=style&index=0&id=c1e7fc88&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1e7fc88",
  null
  
)

export default component.exports